import { render } from "./umrahPackageTable.vue?vue&type=template&id=35279f92&scoped=true"
import script from "./umrahPackageTable.vue?vue&type=script&lang=js"
export * from "./umrahPackageTable.vue?vue&type=script&lang=js"

import "./umrahPackageTable.vue?vue&type=style&index=0&id=35279f92&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35279f92"]])

export default __exports__